<div class="data_loading" *ngIf="ShowLoader" [ngStyle]="CStyle">
  <mat-spinner></mat-spinner> Loading...
</div>
